var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 781.975,
    height: 644.092,
    viewBox: "0 0 781.975 644.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2864",
    "data-name": "Rectangle 2864",
    width: 725.285,
    height: 644.092,
    fill: "#e4e4e4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2907",
    "data-name": "Rectangle 2907",
    width: 185.305,
    height: 233.157,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_83802",
    "data-name": "Group 83802",
    transform: "translate(-1028.078 -275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83765",
    "data-name": "Group 83765",
    transform: "translate(-121.733 -232.219)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83673",
    "data-name": "Group 83673",
    transform: "translate(1178.155 507.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83672",
    "data-name": "Group 83672",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43602",
    "data-name": "Path 43602",
    d: "M417.86,287.532c70.282-24.983,222.4,76.793,236.248-11.743s-98.214-87.65-76.808-174.975-68-146.434-133.471-54.551S298.4-10.434,145.253,61.336C1.057,128.912,24.532,401.429,244.164,398.684c92.776-1.159,118.025-91.362,173.7-111.153",
    transform: "translate(33.628 0)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43603",
    "data-name": "Path 43603",
    d: "M267.493,238.663c13.641-20.119,38.029-50.6,75.887-45.484S424.467,240,505.894,238.663,609.983,353.772,554.58,413.491,374.1,316.233,277.567,359.045,248.824,266.2,267.493,238.663",
    transform: "translate(140.292 119.071)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43605",
    "data-name": "Path 43605",
    d: "M69.369,106.9A34.685,34.685,0,1,1,34.685,72.22,34.684,34.684,0,0,1,69.369,106.9",
    transform: "translate(18.655 -42.353)",
    fill: "#e4e4e4"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_43607",
    "data-name": "Path 43607",
    d: "M2598.61,743.08H2194.575a5.677,5.677,0,0,1-5.677-5.677V405.944a5.677,5.677,0,0,1,5.677-5.677H2598.61a5.678,5.678,0,0,1,5.677,5.677V737.4a5.678,5.678,0,0,1-5.677,5.677",
    transform: "translate(-896.924 3.867)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43608",
    "data-name": "Path 43608",
    d: "M474.671,3174.717S449.323,3152.361,459.3,3131s21.146-43.4-.6-59.2S440.37,3019.6,440.37,3019.6s13.554,25.951,36.259,38.848,33.255,21.761,25.654,41.765,5.741,23.359,6.368,41.8-10.127,36.33-10.127,36.33Z",
    transform: "translate(737.152 -2300.303)",
    fill: "#e3e3e3",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43610",
    "data-name": "Path 43610",
    d: "M73.323,3634.7s-28.011-9.323-25.54-25.816,5.767-33.7-17.3-39.441S0,3538.611,0,3538.611s18.949,14.342,42.017,17.927,34.6,7.171,33.778,22.23,11.534,14.342,17.3,26.533,1.648,26.533,1.648,26.533Z",
    transform: "translate(1124.26 -2756.744)",
    fill: "#e3e3e3",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43611",
    "data-name": "Path 43611",
    d: "M2661.144,452h-465.7c-3.614,0-6.544-2.542-6.544-5.677V405.945c0-3.136,2.93-5.677,6.544-5.677h465.7c3.614,0,6.544,2.542,6.544,5.677v40.376c0,3.136-2.93,5.677-6.544,5.677",
    transform: "translate(-896.924 3.867)",
    fill: "#040405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43612",
    "data-name": "Path 43612",
    d: "M908.89,4097.682l-13.973,28.763,59.7,4.907-29.442-31.078Z",
    transform: "translate(234.426 -3250.777)",
    fill: "#74b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43613",
    "data-name": "Path 43613",
    d: "M2294.989,4106.8l5.993,16.709,47.058.672-37.647-25.546Z",
    transform: "translate(-990.225 -3248.617)",
    fill: "#74b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43614",
    "data-name": "Path 43614",
    d: "M1019.276,2254.582s-3.833,13.415-1.917,32.579l-13.415,88.155-49.827,99.654,23,7.666,57.493-95.821,21.081-82.406Z",
    transform: "translate(188.989 -1626.889)",
    fill: "#37456d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43615",
    "data-name": "Path 43615",
    d: "M1539.226,2191l67.075,229.97-23,9.582-76.657-197.391s-12.918-9.125-17.958-34.267Z",
    transform: "translate(-281.133 -1570.971)",
    fill: "#465383"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43616",
    "data-name": "Path 43616",
    d: "M2205.094,2138.057l3.969,6.383s7.666-1.916,9.582,3.833,0,5.749,0,5.749,5.56,12.5-5.749,15.331c-7.666,1.917-13.415-17.248-13.415-17.248l-5.785-6.925Z",
    transform: "translate(-901.144 -1524.412)",
    fill: "#f1978c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2905",
    "data-name": "Rectangle 2905",
    width: 48.323,
    height: 60.32,
    transform: "translate(1132.967 699.027) rotate(-76.907)",
    fill: "#465383"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43617",
    "data-name": "Path 43617",
    d: "M1876.077,1221.352s15.331,21.081,23,55.576l30.663,55.576-15.331,9.582-29.939-34.963Z",
    transform: "translate(-621.818 -718.227)",
    fill: "#ff586c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43618",
    "data-name": "Path 43618",
    d: "M1495.929,1094.185l30.663,15.331s11.5,0,7.666,118.818c0,0-26.83,11.5-55.576,5.749V1115.266Z",
    transform: "translate(-272.332 -606.391)",
    fill: "#ff586c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43619",
    "data-name": "Path 43619",
    d: "M1265.269,1094.185s-30.663,23-44.078,78.573a279.971,279.971,0,0,0-3.833,74.741l17.248,1.916,13.415-65.637,21.081-49.348s9.582-17.248-3.833-40.245",
    transform: "translate(-41.672 -606.391)",
    fill: "#ff586c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43620",
    "data-name": "Path 43620",
    d: "M1164.394,2369.048l-1.917,13.415v5.749h-3.833s-3.833,15.332-13.415,13.415-7.666-11.5,0-21.081c0,0,5.749-7.666,5.41-13.24Z",
    transform: "translate(26.623 -1726.023)",
    fill: "#f1978c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43621",
    "data-name": "Path 43621",
    d: "M1621.744,1094.185l30.663,9.582-1.917,13.415s-21.081-7.666-28.746-23",
    transform: "translate(-398.147 -606.391)",
    fill: "#ff3f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43622",
    "data-name": "Path 43622",
    d: "M1672.338,573.966c-.277,21.424-11.146,33.174-19.593,31.855-14.129-2.205-25.73-27.291-25.73-27.291-4.29-3.579-4.236-28.786,13.988-33.7s33.787,7.213,31.336,29.136",
    transform: "translate(-400.731 -122.311)",
    fill: "#f1978c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43623",
    "data-name": "Path 43623",
    d: "M1649.745,922.407l-1.172-27.2-19.164-7.666-7.666,24.914Z",
    transform: "translate(-398.147 -424.658)",
    fill: "#f1978c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43624",
    "data-name": "Path 43624",
    d: "M1653.3,474.973c-9.582-9.582-23,0-23,0l-20.864,1.726a24.482,24.482,0,0,0-11.375,3.578c-5.249,3.355-9.3,8.795-11.328,16.6-4.849,18.639,9.14,32.065,9.14,32.065l3.041-14.072,10.338-10.217s2.807,3.936,6.89,2.633c2.81-.9,3.489-5.8,3.639-8.77,7.547.37,18.168.6,23.934-.548,9.582-1.916,17.248-15.331,9.582-23",
    transform: "translate(-366.459 -58.086)",
    fill: "#4e3644"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43625",
    "data-name": "Path 43625",
    d: "M1689.82,719.776a9.9,9.9,0,1,1-8.251-11.3,9.9,9.9,0,0,1,8.251,11.3",
    transform: "translate(-440.713 -267.074)",
    fill: "#f1978c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43626",
    "data-name": "Path 43626",
    d: "M1712.518,881.223s.255,18.1,15.59,21.151l.425,10.19s-22.065-5.123-16.014-31.341",
    transform: "translate(-477.054 -419.104)",
    fill: "#ffa59a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43627",
    "data-name": "Path 43627",
    d: "M1454.767,1455.561l-2.017,45.714-3.361,14.117s-2.689-38.319,5.378-59.831",
    transform: "translate(-246.193 -924.199)",
    fill: "#ff3f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43628",
    "data-name": "Path 43628",
    d: "M1947.389,1600.539l-1.722,40.057,6.733,6.392Z",
    transform: "translate(-683.018 -1051.699)",
    fill: "#ff3f56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2906",
    "data-name": "Rectangle 2906",
    width: 631.836,
    height: 5.071,
    transform: "translate(1115.677 875.502)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43629",
    "data-name": "Path 43629",
    d: "M2379.747,553.766a5.4,5.4,0,1,1-5.4-5.4,5.4,5.4,0,0,1,5.4,5.4",
    transform: "translate(-1055.264 -126.375)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43630",
    "data-name": "Path 43630",
    d: "M2523.667,555.942a5.4,5.4,0,1,1-5.4-5.4,5.4,5.4,0,0,1,5.4,5.4",
    transform: "translate(-1181.834 -128.289)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43631",
    "data-name": "Path 43631",
    d: "M2663.658,555.714a5.4,5.4,0,1,1-5.4-5.4,5.4,5.4,0,0,1,5.4,5.4",
    transform: "translate(-1304.947 -128.088)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43632",
    "data-name": "Path 43632",
    d: "M4707.843,1071.981h-177.5a3.9,3.9,0,0,1-3.9-3.9v-55.51a3.9,3.9,0,0,1,3.9-3.9h177.5a3.9,3.9,0,0,1,3.9,3.9v55.51a3.9,3.9,0,0,1-3.9,3.9",
    transform: "translate(-2952.65 -531.184)",
    fill: "#3c9bfa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_83738",
    "data-name": "Group 83738",
    transform: "translate(1335.21 482.117)",
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83737",
    "data-name": "Group 83737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83736",
    "data-name": "Group 83736",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43633",
    "data-name": "Path 43633",
    d: "M2728.938,1280.251h-177.5a3.9,3.9,0,0,1-3.9-3.9V1051a3.9,3.9,0,0,1,3.9-3.9h177.5a3.9,3.9,0,0,1,3.9,3.9V1276.35a3.9,3.9,0,0,1-3.9,3.9",
    transform: "translate(-2547.534 -1047.094)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_43634",
    "data-name": "Path 43634",
    d: "M4720.652,1782.851h-177.5a3.9,3.9,0,0,1-3.9-3.9v-55.51a3.9,3.9,0,0,1,3.9-3.9h177.5a3.9,3.9,0,0,1,3.9,3.9v55.51a3.9,3.9,0,0,1-3.9,3.9",
    transform: "translate(-2963.914 -1156.352)",
    fill: "#3c9bfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43635",
    "data-name": "Path 43635",
    d: "M4733.461,2506.527h-177.5a3.9,3.9,0,0,1-3.9-3.9v-55.51a3.9,3.9,0,0,1,3.9-3.9h177.5a3.9,3.9,0,0,1,3.9,3.9v55.51a3.9,3.9,0,0,1-3.9,3.9",
    transform: "translate(-2975.18 -1792.779)",
    fill: "#3c9bfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43636",
    "data-name": "Path 43636",
    d: "M5258.5,1233.8h-80.035a1.145,1.145,0,0,1-1.142-1.142v-3.506a1.145,1.145,0,0,1,1.142-1.142H5258.5a1.146,1.146,0,0,1,1.142,1.142v3.506a1.146,1.146,0,0,1-1.142,1.142",
    transform: "translate(-3525.059 -724.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43637",
    "data-name": "Path 43637",
    d: "M5248.891,1960.684h-80.035a1.145,1.145,0,0,1-1.142-1.142v-3.506a1.145,1.145,0,0,1,1.142-1.142h80.035a1.145,1.145,0,0,1,1.143,1.142v3.506a1.145,1.145,0,0,1-1.143,1.142",
    transform: "translate(-3516.611 -1363.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43638",
    "data-name": "Path 43638",
    d: "M5268.1,2697.17h-80.035a1.145,1.145,0,0,1-1.142-1.142v-3.506a1.146,1.146,0,0,1,1.142-1.143H5268.1a1.146,1.146,0,0,1,1.143,1.143v3.506a1.146,1.146,0,0,1-1.143,1.142",
    transform: "translate(-3533.508 -2011.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43639",
    "data-name": "Path 43639",
    d: "M4668.935,1173.294l16.794,17.565,28.567-25.286-28.761,15.249Z",
    transform: "translate(-3077.965 -669.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43640",
    "data-name": "Path 43640",
    d: "M4664.131,1864.95l16.793,17.565,28.568-25.286-28.761,15.249Z",
    transform: "translate(-3073.741 -1277.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43641",
    "data-name": "Path 43641",
    d: "M4678.542,2571.016l16.793,17.565L4723.9,2563.3l-28.761,15.249Z",
    transform: "translate(-3086.414 -1898.383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43642",
    "data-name": "Path 43642",
    d: "M2852.126,1715.365l33.608,48.785,57.173-70.229-57.559,42.352Z",
    transform: "translate(-1655.041 -769.107) rotate(-7)",
    fill: "#14c708"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2908",
    "data-name": "Rectangle 2908",
    width: 781.975,
    height: 524.694,
    transform: "translate(1028.078 355.879)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2909",
    "data-name": "Rectangle 2909",
    width: 781.975,
    height: 524.695,
    transform: "translate(1028.078 355.879)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour);
export default __webpack_public_path__ + "static/media/four.402bf3730f3ae01c7f5ff274bb031ab0.svg";
export { ForwardRef as ReactComponent };